// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"3f496b0c","58":"f8b46a8a","62":"8a9cb54c","135":"2d01a6f1","373":"63f2279d","481":"bfc8c2ff","521":"e4f127b0","573":"2c15036b","604":"6ffb5d62","642":"4941dad2","697":"4367357f","939":"b5e585c5"}[chunkId] + ".chunk.js";
};